<template>
  <tippy
    theme="wila"
    animation="fade"
    arrow="true"
    allow-html="true"
    interactive="true"
    max-width="440px"
  >
    <template #trigger>
      <div class="c-facet__tooltip ml-2 d-flex align-items-center">
        <i class="far fa-info-circle text-primary"></i>
      </div>
    </template>

    <div class="tooltip__body">
      <div v-if="tooltipImage" class="tooltip__body--image">
        <img
          :src="tooltipImage"
          :alt="tooltipImageAlt"
          loading="lazy"
          width="100px"
          height="100px"
        />
      </div>

      <div class="tooltip__body--content" v-html="tooltipText"></div>
    </div>
  </tippy>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    tooltipText: {
      type: String,
      required: true,
      default: ''
    },
    tooltipImage: {
      type: String,
      required: false,
      default: null
    },
    tooltipImageAlt: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>

<style lang="scss">
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.tippy-tooltip.wila-theme > .tippy-arrow {
  border-top-color: $white;
  border-bottom-color: $white;
}

.tippy-tooltip {
  background-color: $white;
  color: $body-color;
  padding: 20px;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.25);
  border-radius: 0;
  display: flex;

  .tippy {
    &-content {
      padding: 0;
    }
  }

  .tooltip {
    &__body {
      text-align: left;
      display: flex;
      gap: 20px;

      &--content {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        align-items: flex-start;
        justify-content: center;
      }

      &--title {
        font-weight: 700;
        font-size: rem(16);
      }

      &--text {
        font-size: rem(14);
        font-weight: 400;

        margin: {
          bottom: unset;
        }
      }

      &--link {
        color: $primary;
        font-size: rem(16);
        font-weight: 700;
        display: inline-block;
        border: none;

        margin: {
          top: 10px;
          bottom: 5px;
        }
      }
    }
  }
}
</style>
